import { Button, Menu, MenuItem, makeStyles } from "@material-ui/core";
import { lang } from "i18nLang";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
  statusButtonActived: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.dark,
    width: "100%",
  },
  statusButtonDisabled: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.primary.dark,
    width: "100%",
  },
}));

const ActionsButton = ({
  disabled,
  onChangeStatus,
  onDelete,
}: {
  disabled: boolean;
  onChangeStatus: Function;
  onDelete: Function;
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleChoose = (disabled: boolean) => (ev) => {
    handleClose(ev);
    onChangeStatus(disabled);
  };

  const handleDelete = (ev) => {
    handleClose(ev);
    onDelete();
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        aria-controls={anchorEl ? `statusEl` : undefined}
        aria-haspopup="true"
        onClick={handleOpen}
        className={
          disabled ? classes.statusButtonDisabled : classes.statusButtonActived
        }
      >
        {disabled ? lang("disabled") : lang("enabled")}
      </Button>
      <Menu
        id={`statusEl`}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleChoose(false)} disabled={!disabled}>
          {lang("enabled")}
        </MenuItem>
        <MenuItem onClick={handleChoose(true)} disabled={disabled}>
          {lang("disabled")}
        </MenuItem>
        <MenuItem onClick={handleDelete}>{lang("delete")}</MenuItem>
      </Menu>
    </>
  );
};

export default ActionsButton;
